<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.workstationNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.workstationName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="workstationNumber" label="编码" width="140" />
      <el-table-column prop="workstationName" label="名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="typeName" label="工位类型" width="120" show-overflow-tooltip />
      <el-table-column prop="divisionName" label="车间" width="120" show-overflow-tooltip />
      <el-table-column prop="productionLineName" label="产线" width="120" show-overflow-tooltip />
      <el-table-column label="运行状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.state === '02'" size="mini" type="success">运行</el-tag>
          <el-tag v-else size="mini" type="info">停机</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.workstationId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.workstationId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.workstationId ? '修改工位' : '新增工位'" :visible.sync="visible" width="640px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="编码" prop="workstationNumber">
          <el-input v-model="form.workstationNumber" />
        </el-form-item>
        <el-form-item label="名称" prop="workstationName">
          <el-input v-model="form.workstationName" />
        </el-form-item>
        <el-form-item label="工位类型">
          <el-select v-model="form.typeId" clearable filterable style="width:100%">
            <el-option v-for="i in typeOptions" :key="i.typeId" :label="i.typeName" :value="i.typeId" />
          </el-select>
        </el-form-item>
        <el-form-item label="车间">
          <el-select v-model="form.divisionId" clearable filterable style="width:100%">
            <el-option v-for="i in divisionOptions" :key="i.divisionId" :label="i.divisionName" :value="i.divisionId" />
          </el-select>
        </el-form-item>
        <el-form-item label="产线">
          <el-select v-model="form.productionLineId" clearable filterable style="width:100%">
            <el-option v-for="i in lineOptions" :key="i.lineId" :label="i.lineName" :value="i.lineId" />
          </el-select>
        </el-form-item>
        <el-form-item label="序列号">
          <el-input v-model="form.serialNumber" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.state" style="width:100%">
            <el-option label="停机" value="01" />
            <el-option label="运行" value="02" />
          </el-select>
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="form.description" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listWorkstation, getWorkstation, saveWorkstation, updateWorkstation, deleteWorkstation
} from '../../api/workstation'
import { selectWorkstationType } from '../../api/workstationType'
import { selectDivision } from '../../api/division'
import { selectProductionLine } from '../../api/productionLine'

function emptyForm() {
  return {
    workstationId: '',
    workstationNumber: '',
    workstationName: '',
    typeId: '',
    divisionId: '',
    productionLineId: '',
    serialNumber: '',
    state: '01',
    description: '',
    active: '1'
  }
}

export default {
  name: 'MesWorkstationPage',
  components: { ListPagination },
  data() {
    return {
      query: { workstationNumber: '', workstationName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      typeOptions: [],
      divisionOptions: [],
      lineOptions: [],
      form: emptyForm(),
      rules: {
        workstationNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        workstationName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listWorkstation({
        currentPage: this.page,
        pageSize: this.pageSize,
        workstationNumber: this.query.workstationNumber,
        workstationName: this.query.workstationName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.visible = true
      selectWorkstationType().then(res => { this.typeOptions = res.data || [] }).catch(() => { this.typeOptions = [] })
      selectDivision().then(res => { this.divisionOptions = res.data || [] }).catch(() => { this.divisionOptions = [] })
      selectProductionLine().then(res => { this.lineOptions = res.data || [] }).catch(() => { this.lineOptions = [] })
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getWorkstation(id).then(res => {
        this.form = Object.assign(emptyForm(), res.data || {})
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = Object.assign({}, this.form)
        const req = payload.workstationId ? updateWorkstation(payload) : saveWorkstation(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.workstationId)
      if (!ids.length) return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteWorkstation(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
